module.exports = __webpack_public_path__ + "img/denimBlue.585773fa.png";